import { auth } from "@utils/firebase";
import { useGetUser } from "@utils/hooks";
import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate, Outlet } from "react-router-dom";

const ShouldBeAuthenticatedRoute = () => {
    const [user, userLoading] = useAuthState(auth);
    const { data: userData, isLoading: isLoadingUserData } = useGetUser();

    if (userLoading || isLoadingUserData) {
        return <></>;
    } else {
        if (user) {
            return <Outlet />;
        } else {
            return <Navigate to="/login" />;
        }
    }
};

export default ShouldBeAuthenticatedRoute;
